'use es6';

import uniqueId from 'transmute/uniqueId';
import { configureGetErrorMessage, configureGetErrorTitle } from 'error-messaging-js';
import { createDangerNotification, createSuccessNotification } from 'ReduxMessenger/utils';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const getPrefix = contentType => `notifications.errors.${contentType}`;
const getErrorTitle = configureGetErrorTitle({
  logSentry: true
});
const getErrorMessage = configureGetErrorMessage({
  logSentry: true
});
const getErrorData = (contentType, action, additionalTranslationOptions, response = {
  responseJSON: {
    errorType: 'default-error'
  }
}) => {
  const data = {
    action,
    additionalTranslationOptions,
    prefixKey: getPrefix(contentType),
    response
  };
  return {
    message: getErrorMessage(data),
    titleText: getErrorTitle(data)
  };
};
const getSuccessData = (contentType, action, options) => {
  const prefix = `notifications.successes.${contentType}.${action}`;
  return {
    message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `${prefix}.message`,
      options: options
    }),
    titleText: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `${prefix}.title`
    })
  };
};
const createDangerNotificationMeta = ({
  titleText,
  message
}, action) => ({
  notification: Object.assign({}, createDangerNotification(titleText, message), {
    ['data-test-id']: `${action}-error`
  })
});
const createSuccessNotificationMeta = ({
  titleText,
  message
}, action) => ({
  notification: Object.assign({}, createSuccessNotification(titleText, message), {
    ['data-test-id']: `${action}-success`
  })
});
export const createTranslatedDangerNotification = (contentType, action, response, additionalTranslationOptions = {}) => createDangerNotificationMeta(getErrorData(contentType, action, additionalTranslationOptions, response), action);
export const createTranslatedSuccessNotification = (contentType, action, options) => createSuccessNotificationMeta(getSuccessData(contentType, action, options), action);
const showDirectMessage = (type, message, id) => {
  message = message || /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "app.somethingIsWrong"
  });
  type = type || 'info';
  id = id || uniqueId();
  return {
    notification: {
      id,
      message,
      type
    }
  };
};
export const showDirectDangerMessage = (message, id) => showDirectMessage('danger', message, id);
export const showDirectSuccessMessage = (message, id) => showDirectMessage('success', message, id);